describe("react-object", function() {
  require("./Value.spec");
  require("./ValueList.spec");

  describe("internal", function() {
    require("./Primitive.spec");
    require("./Complex.spec");
    require("./Function.spec");
    require("./Date.spec");
    require("./Text.spec");
  });
});
